import { CornerLabelField } from '@/components/ui/corner-label-field';
import { formatTicketDocumentDateTime } from '@/utils/ticket-document-time';
import { useTranslation } from 'react-i18next';

type TicketCreatedAtFieldProps = {
  createdAt?: Date | string | null;
};

export function TicketCreatedAtField({ createdAt }: TicketCreatedAtFieldProps) {
  const { t } = useTranslation(['components.ticket']);

  if (!createdAt) {
    return <div />;
  }

  return (
    <CornerLabelField label={t('components.ticket:fields.createdAt')}>
      <div className="textbox-readonly">
        <p className="text-dark">{formatTicketDocumentDateTime(createdAt)}</p>
      </div>
    </CornerLabelField>
  );
}
